const applets = [
    {
        "text": "Case Basic Information",
        "icon": "/image/business/newborn.svg",
        "id": "NewbornApplet",
        "path": "newborn",
        "category": "Screening Management"
    },
    // {
    //     "text": "Update Collection Date",
    //     "icon": "/image/business/update-collection-date.svg",
    //     "id": "UpdateCollectionDateApplet",
    //     "path": "updateCollectionDate",
    //     "category": "Screening Management"
    // },
    // {
    //     "text": "Update Send Uid Date",
    //     "icon": "/image/business/update-test-date.svg",
    //     "id": "UpdateTestDateApplet",
    //     "path": "updateTestDate",
    //     "category": "Screening Management"
    // },
    {
        "text": "Update Report Date",
        "icon": "/image/business/reportDate.svg",
        "id": "UpdateReportDateApplet",
        "path": "updateReportDate",
        "category": "Test Management"
    },
    {
        "text": "Print Test Report",
        "icon": "/image/business/print-test-report.svg",
        "id": "PrintTestReportApplet",
        "path": "printTestReport",
        "category": "Test Management"
    },
    {
        "text": "Approve of Issuing Report",
        "icon": "/image/business/approve-of-issuing-report.svg",
        "id": "ApproveOfIssuingReportApplet",
        "path": "approveOfIssuingReport",
        "category": "Test Management"
    },
    {
        "text": "No Report List",
        "icon": "/image/business/no-report-list.svg",
        "id": "NoReportListApplet",
        "path": "noReportList",
        "category": "Test Management"
    },
    {
        "text": "Positive Report Form",
        "icon": "/image/business/test-results.svg",
        "id": "PositiveReportFormApplet",
        "path": "positiveReportForm",
        "category": "Test Management"
    },
    {
        "text": "Print Report List",
        "icon": "/image/business/print-report-list.svg",
        "id": "PrintReportListApplet",
        "path": "printReportList",
        "category": "Test Management"
    },
    {
        "text": "Hospital",
        "icon": "/image/business/hospital.svg",
        "id": "HospitalApplet",
        "path": "hospital",
        "category": "System Management"
    },
    {
        "text": "Account",
        "icon": "/image/business/account.svg",
        "id": "AccountApplet",
        "path": "account",
        "category": "System Management"
    },
    {
        "text": "Organization",
        "icon": "/image/business/organization.svg",
        "id": "OrganizationApplet",
        "path": "organization",
        "category": "System Management"
    },
    {
        "text": "Report Unlock",
        "icon": "/image/business/easy-access.svg",
        "id": "ReportUnlockApplet",
        "path": "reportUnlock",
        "category": "System Management"
    }
]


export default applets;